import { kijs, resolutions, default_zoom, default_coords } from '../config';
import { wmsLayer, wmsBWLayer } from '../baseLayers/mapLayers';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { ScaleLine } from 'ol/control.js';
import { containsExtent, getWidth, getHeight, getIntersection } from 'ol/extent';
import DeepEqual from 'deep-equal';
import { defaults as defaultInteractions } from 'ol/interaction';

var map = new Map({
	//	renderer: 'webgl',
	crossOrigin: 'anonymous',
	layers: [
		//	wmsBWLayer
	],
	interactions: defaultInteractions({ altShiftDragRotate: false, pinchRotate: false }),
	controls: [
		//	new ol.control.Attribution(),
		//	new ol.control.Rotate(),
		new ScaleLine()
		//	new ol.control.FullScreen({tipLabel:'Pilnekrāna režīms'}),
		//	mouseControl
	],
	//	view: view,
	logo: false
});

export const view = new View({
	center: default_coords,
	zoom: default_zoom,
	maxZoom: 18,
	minZoom: 4, //11 / 6
	projection: 'EPSG:3857',
	resolutions: resolutions
	//extent: [ 1151097.9067130184, 6754131.55680217, 4132753.5060603814, 8551930.462069038 ]
});
map.setView(view);

const MAX_ZOOM_OUT_OF_BALTICS = 9;

let OLD_NEWCENTER = [];

//console.log(map_currentResolution, map_currentCenter)
//https://stackoverflow.com/questions/27200086/restrict-pan-outside-wms-extent-in-openlayers3
let constrainPan = e => {
	const type = e.type;
	const newValue = e.target.get(e.key);
	const oldValue = e.oldValue;

	if (type === 'change:resolution' && oldValue < newValue) {
		// Always allow zoom-out.
		return;
	}
	
	const currentZoom = Math.round(map.getView().getZoom());

	if (currentZoom < MAX_ZOOM_OUT_OF_BALTICS) {
		return;
	}

	if (DeepEqual(oldValue, newValue)) {
		// Do nothing when event doesn't change the value
		return;
	}
	
	const extent = [2313795, 7143715, 3164430, 8338310];
	const visibleExtent = map.getView().calculateExtent(map.getSize());
	
	const intersection = getIntersection(visibleExtent, extent);
	const modify = !DeepEqual(intersection, visibleExtent);

	if (intersection[0] !== Infinity) {
		return;
	}
	
	if (intersection[0] === Infinity) {
		
		if (type === 'change:center') {
			const newCenter = newValue.slice(0);
			
			if (DeepEqual(OLD_NEWCENTER, oldValue)) {
				OLD_NEWCENTER = [...newValue];
				return;
			}
			OLD_NEWCENTER = [...newValue];

			if (getWidth(visibleExtent) !== getWidth(intersection)) {
				newCenter[0] = oldValue[0];
			}

			if (getHeight(visibleExtent) !== getHeight(intersection)) {
				newCenter[1] = oldValue[1];
			}
			
			map.getView().setCenter(newCenter);
		} else if (type === 'change:resolution') {
			map.getView().setResolution(oldValue);
		}
	}
};

map.getView().on('change:resolution', constrainPan);
//map.getView().on('change:zoom', constrainPan);
map.getView().on('change:center', constrainPan);

var mapIni = function({mapID}) {
	/*Inicializējam karti*/
	map.setTarget(document.getElementById(mapID));

	//mapboxgl.accessToken = 'pk.eyJ1IjoibWF0aXNzemVydmVucyIsImEiOiJjamxyeDloeGgwMW55M2tta2Q3MHV4b2tlIn0.Vzujok-6MfJSS2PV1jShNA';
	/*
	const map = new mapboxgl.Map({
		container: 'map_mb',
		style: 'https://maps.kartes.lv/kijs/vectortiles/styles/baltic-vt.php?key=JSED',
		center: [24.0866093,56.9533676],
		zoom: 9
	});
	*/
};

export { mapIni, map };
